export default __webpack_public_path__ + "static/tabsSectionBg-fdce12f84744723535bf3aab4879f0ba.png";